const listColumn = {
  item: 'item',
  checkupItem: 'checkupItem',
  comparingCheckupItemOne: 'comparingCheckupItemOne',
  comparingCheckupItemTwo: 'comparingCheckupItemTwo',
  lookupItems: 'lookupItems',
};
const listHideColumn = ['lookupItems'];

const mapRateIndicatorId = {
  NON_BANKING: {
    RAPID_EQUITY_ISSUANCE: {
      key: 5,
      icon: 'icon-rapid-equity-issuance',
    },
    REVENUE_GROWTH: {
      key: 6,
      icon: 'icon-revenue-growth',
    },
    PROFIT_GROWTH: {
      key: 7,
      icon: 'icon-profit-growth',
    },
    GROSS_PROFIT_MARGIN: {
      key: 8,
      icon: 'icon-gross-profit-margin',
    },
    CFO_QUALITY: {
      key: 9,
      icon: 'icon-cfo-quality',
    },
    OPERATION_EFFICIENCY: {
      key: 10,
      icon: 'icon-operation-efficiency',
    },
    DEBT_PRESSURE: {
      key: 11,
      icon: 'icon-debt-pressure',
    },
    CAPITAL_STRUCTURE: {
      key: 12,
      icon: 'icon-capital-structure',
    },
    ROE: {
      key: 13,
      icon: 'icon-roe',
    },
    FINANCIAL_PLANNING: {
      key: 14,
      icon: 'icon-financial-planning',
    },
  },
  BANKING: {
    DEPOSIT_GROWTH: {
      key: 15,
      icon: 'icon-rapid-equity-issuance',
    },
    CREDIT_GROWTH: {
      key: 16,
      icon: 'icon-revenue-growth',
    },
    INTEREST_PROFIT_GROWTH: {
      key: 17,
      icon: 'icon-gross-profit-margin',
    },
    NIM_RATIO: {
      key: 18,
      icon: 'icon-profit-growth',
    },
    LDR_Ratio: {
      key: 19,
      icon: 'icon-cfo-quality',
    },
    NPL_Ratio: {
      key: 20,
      icon: 'icon-operation-efficiency',
    },
    CAR_Ratio: {
      key: 21,
      icon: 'icon-financial-planning',
    },
    Business_Plan: {
      key: 22,
      icon: 'icon-debt-pressure',
    },
  },
};

export default {
  listColumn,
  listHideColumn,
  mapRateIndicatorId,
  idFaCheckup: 'idFaCheckup',
  defaultOption: 'VolPriceIncrease',
  maxRowData: 50,
};
